module.exports = __webpack_public_path__ + "img/پیچیده.6d6add06.png";